export const {
  PUBLIC_URL,
  NODE_ENV,
  REACT_APP_BASENAME,
  REACT_APP_DOMAIN,
  REACT_APP_ENV,
  REACT_APP_VERSION,
} = process.env

const { api } = document.getElementById('root').dataset || {}

export const API_URL = api

export const SIGNALR_URL = `${api}/certificateHub`

export const ACCEPTOR_ROLES = ['SystemAdmin', 'DealerAdmin', 'User']
